(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pivot-header-list"] && !Shopify.designMode) return;
  try {
    class PivotHeaderOverflowControl extends HTMLElement {
    connectedCallback() {
      console.log('Holaa');

      this.items = [...this.querySelectorAll('.pivot-header-list__items > li')];
      this.referenceTop = this.items[0]?.getBoundingClientRect().top;

      if (!this.referenceTop) return;

      this.moreItem = document.createElement('li');
      this.moreItem.role = 'presentation';
      this.moreItem.classList.add('menu-list__list-item');
      this.moreItem.innerHTML = `<a role="menuitem" aria-haspopup="true" href="#" class="menu-list__link">
            <span class="menu-list__link-title">Más</span>
        </a>
        <div class="pivot-submenu"><ul></ul></div>`;
      this.pivotSubmenu = this.moreItem.querySelector('.pivot-submenu ul');

      this.recalc();

      window.addEventListener('resize', this.recalc.bind(this));
    }
    recalc() {
      const overflowed = this.items.findIndex((el) => {
        const itemTop = el.getBoundingClientRect().top;
        // Si la posición top es mayor (con un pequeño margen de error), significa que está en otra fila
        const isOverflowing = Math.abs(itemTop - this.referenceTop) > 5; // 5px como margen de error
        return isOverflowing;
      });
      console.log('Overflowed', overflowed);
      if(overflowed < 0) return;
      this.items[overflowed]?.insertAdjacentElement('beforebegin', this.moreItem);
      this.pivotSubmenu?.append(...this.items.slice(overflowed));
    }
  }
  if (!customElements.get('pivot-header-list')) {
    customElements.define('pivot-header-list', PivotHeaderOverflowControl);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pivot-responsive-video"] && !Shopify.designMode) return;
  try {
    class PivotResponsiveVideo extends HTMLElement {
    connectedCallback() {
      console.log("VIDEO RESPONSIVE");
      this.desktopVideo = this.querySelector('.pivot-desktop-video');
      this.mobileVideo = this.querySelector('.pivot-mobile-video');
      this.responsivePlay();
      window.addEventListener('resize', this.responsivePlay);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.responsivePlay);
    }
    responsivePlay = () => {
      if (window.innerWidth > 750) {
        if (this.desktopVideo) this.desktopVideo.play();
        if (this.mobileVideo) this.mobileVideo.pause();
      } else {
        if (this.desktopVideo) this.desktopVideo.pause();
        if (this.mobileVideo) this.mobileVideo.play();
      }
    };
  }
  if(!customElements.get('pivot-responsive-video')) {
    customElements.define('pivot-responsive-video', PivotResponsiveVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pivot-slideshow-controls"] && !Shopify.designMode) return;
  try {
    class PivotCarouselControlsWrapper extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (!this.isConnected) return;
      this.slider = this.closest('slideshow-component');
      console.log('Slider', this.slider);
      this.slider.addEventListener('slideshow:select', (e) => {
        console.log('Slide Change', e);
        const index = e.detail.index;
        console.log('Selected', index);
        this.querySelector('.slideshow-control[aria-selected="true"]')?.setAttribute('aria-selected', 'false');

        const columns = parseInt(this.getAttribute('columns')) || 1;
        const columnsMb = parseInt(this.getAttribute('columns-mb')) || 1;
        const pageIndexDesktop = Math.floor(index / columns);
        const pageIndexMobile = Math.floor(index / columnsMb);

        // Update desktop dots
        const desktopDot = this.querySelector(`.pvt-controls-dk button[data-slide="${pageIndexDesktop * columns}"]`);
        if (desktopDot) desktopDot.setAttribute('aria-selected', 'true');

        // Update mobile dots
        console.log('Mobile Dot', { pageIndexMobile, columnsMb, dataSlide: pageIndexMobile * columnsMb });
        const mobileDot = this.querySelector(`.pvt-controls-mb button[data-slide="${pageIndexMobile * columnsMb}"]`);
        if (mobileDot) mobileDot.setAttribute('aria-selected', 'true');

        // Update counter if present
        const counter = this.querySelector('[ref="current"]');
        if (counter) counter.textContent = pageIndexDesktop + 1;
      });
    }
  }
  if (!customElements.get('pivot-carousel-controls-wrapper')) {
    customElements.define('pivot-carousel-controls-wrapper', PivotCarouselControlsWrapper);
  }
  } catch(e) { console.error(e); }
})();

})();
